import React from 'react';
import styled, {keyframes} from 'styled-components';

// let Colors = ['', '', '', '']
const Colors1 = ['#FFFFFF', '#241F00', '#FAE132', '#FFF8C6'];
const Colors2 = ['#002445', '#0182FA', '#FF8CF4', '#FAFE34', '#FF0505'];
const Colors3 = ['#F0F0F0', '#BFBFBF', '#767676', '#454545'];
const Colors4 = ['#F0F0F0', '#BFBFBF', '#767676', '#012114'];
const Colors5 = ['#012114', '#012114', '#6DFB00', '#FFFFFF'];


const boxOneAnimation = keyframes`
  0% { background-color: ${Colors1[0]}; opacity: 1; }
  10% { background-color: ${Colors1[2]}; opacity: 1; }
  20% { background-color: ${Colors1[2]}; opacity: 1; }
  30% { background-color: ${Colors1[1]}; opacity: 1; }
  40% { background-color: ${Colors1[1]}; opacity: 1; }
  50% { background-color: ${Colors1[3]}; opacity: 1; }
  60% { background-color: ${Colors1[2]}; opacity: 1; }
  70% { background-color: ${Colors1[0]}; opacity: 1; }
  80% { background-color: ${Colors1[1]}; opacity: 0.5; }
  90% { background-color: ${Colors1[2]}; opacity: 0.2; }
  100% { background-color: none; opacity: 0; }
`;

const boxTwoAnimation = keyframes`
  0% { background-color: ${Colors2[0]}; opacity: 1; }
  10% { background-color: ${Colors2[1]}; opacity: 1; }
  20% { background-color: ${Colors2[2]}; opacity: 1; }
  30% { background-color: ${Colors2[0]}; opacity: 1; }
  40% { background-color: ${Colors2[1]}; opacity: 1; }
  50% { background-color: ${Colors2[3]}; opacity: 1; }
  60% { background-color: ${Colors2[0]}; opacity: 1; }
  70% { background-color: ${Colors2[1]}; opacity: 1; }
  80% { background-color: ${Colors2[4]}; opacity: 1; }
  90% { background-color: ${Colors2[1]}; opacity: 1; }
  100% { background-color: none; opacity: 0; }
`;

const boxThreeAnimation = keyframes`
  0% { background-color: ${Colors3[0]}; opacity: 1; }
  10% { background-color: ${Colors3[1]}; opacity: 1; }
  20% { background-color: ${Colors3[2]}; opacity: 1; }
  30% { background-color: ${Colors3[3]}; opacity: 1; }
  40% { background-color: ${Colors3[0]}; opacity: 1; }
  50% { background-color: ${Colors3[1]}; opacity: 1; }
  60% { background-color: ${Colors3[2]}; opacity: 1; }
  70% { background-color: ${Colors3[3]}; opacity: 1; }
  80% { background-color: ${Colors3[0]}; opacity: 0.5; }
  90% { background-color: ${Colors3[1]}; opacity: 0.2; }
  100% { background-color: none; opacity: 0; }
`;


const boxFourAnimation = keyframes`
  0% { background-color: ${Colors4[1]}; opacity: 1; }
  10% { background-color: ${Colors4[0]}; opacity: 1; }
  20% { background-color: ${Colors4[2]}; opacity: 1; }
  30% { background-color: ${Colors4[3]}; opacity: 1; }
  40% { background-color: ${Colors4[1]}; opacity: 1; }
  50% { background-color: ${Colors4[0]}; opacity: 1; }
  60% { background-color: ${Colors4[0]}; opacity: 1; }
  70% { background-color: ${Colors4[1]}; opacity: 1; }
  80% { background-color: ${Colors4[2]}; opacity: 1; }
  90% { background-color: ${Colors4[1]}; opacity: 1; }
  100% { background-color: none; opacity: 0; }
`;

const boxFiveAnimation = keyframes`
  0% { background-color: ${Colors5[0]}; opacity: 1; }
  10% { background-color: ${Colors5[1]}; opacity: 1; }
  20% { background-color: ${Colors5[3]}; opacity: 1; }
  30% { background-color: ${Colors5[0]}; opacity: 1; }
  40% { background-color: ${Colors5[2]}; opacity: 1; }
  50% { background-color: ${Colors5[3]}; opacity: 1; }
  60% { background-color: ${Colors5[0]}; opacity: 1; }
  70% { background-color: ${Colors5[1]}; opacity: 1; }
  80% { background-color: ${Colors5[2]}; opacity: 1; }
  90% { background-color: ${Colors5[1]}; opacity: 1; }
  100% { background-color: none; opacity: 0; }
`;



const Holder = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  width: 100%;
  animation-fill-mode: both;
  aspect-ratio: 4/5;

  img {
    object-fit: contain;
  }

  &.animate-1 {
    > div {
      &:nth-child(5n + 1) {
        animation: ${boxOneAnimation} 3s linear;
      }

      &:nth-child(5n + 2 ) {
        animation: ${boxOneAnimation} 3s linear;
        animation-delay: -1s
      }

      &:nth-child(5n + 3 ) {
        animation: ${boxOneAnimation} 3s linear;
        animation-delay: -0.5s
      }

      &:nth-child(5n + 4 ) {
        animation: ${boxOneAnimation} 3s linear;
        animation-delay: -2s
      }

      &:nth-child(5n + 5 ) {
        animation: ${boxOneAnimation} 3s linear;
        animation-delay: -1.5s
      }
    }
  }
  &.animate-2 {
    > div {
      &:nth-child(5n + 1) {
        animation: ${boxTwoAnimation} 3s linear;
      }

      &:nth-child(5n + 2 ) {
        animation: ${boxTwoAnimation} 3s linear;
        animation-delay: -1s
      }

      &:nth-child(5n + 3 ) {
        animation: ${boxTwoAnimation} 3s linear;
        animation-delay: -0.5s
      }

      &:nth-child(5n + 4 ) {
        animation: ${boxTwoAnimation} 3s linear;
        animation-delay: -1.5s
      }

      &:nth-child(5n + 5 ) {
        animation: ${boxTwoAnimation} 3s linear;
        animation-delay: -2s
      }
    }
  }
  &.animate-3 {
    > div {
      &:nth-child(5n + 1) {
        animation: ${boxThreeAnimation} 3s linear;
      }

      &:nth-child(5n + 2 ) {
        animation: ${boxThreeAnimation} 3s linear;
        animation-delay: -0.5s
      }

      &:nth-child(5n + 3 ) {
        animation: ${boxThreeAnimation} 3s linear;
        animation-delay: -1s
      }

      &:nth-child(5n + 4 ) {
        animation: ${boxThreeAnimation} 3s linear;
        animation-delay: -2s
      }

      &:nth-child(5n + 5 ) {
        animation: ${boxThreeAnimation} 3s linear;
        animation-delay: -1.5s
      }
    }
  }
    &.animate-4 {
      > div {
        &:nth-child(5n + 1) {
          animation: ${boxFourAnimation} 3s linear;
        }
  
        &:nth-child(5n + 2 ) {
          animation: ${boxFourAnimation} 3s linear;
          animation-delay: -1s
        }
  
        &:nth-child(5n + 3 ) {
          animation: ${boxFourAnimation} 3s linear;
          animation-delay: -0.5s
        }
  
        &:nth-child(5n + 4 ) {
          animation: ${boxFourAnimation} 3s linear;
          animation-delay: -2s
        }
  
        &:nth-child(5n + 5 ) {
          animation: ${boxFourAnimation} 3s linear;
          animation-delay: -1.5s
        }
      }
    }
    &.animate-5 {
      > div {
        &:nth-child(5n + 1) {
          animation: ${boxFiveAnimation} 3s linear;
        }
  
        &:nth-child(5n + 2 ) {
          animation: ${boxFiveAnimation} 3s linear;
          animation-delay: -1s
        }
  
        &:nth-child(5n + 3 ) {
          animation: ${boxFiveAnimation} 3s linear;
          animation-delay: -0.5s
        }
  
        &:nth-child(5n + 4 ) {
          animation: ${boxFiveAnimation} 3s linear;
          animation-delay: -2s
        }
  
        &:nth-child(5n + 5 ) {
          animation: ${boxFiveAnimation} 3s linear;
          animation-delay: -1.5s
        }
      }
    }
  }
`;

const Column = styled.div`
  height: 100%;
`;


function PortraitAnimation( {image, color} ) {

  const divStyle = {
    backgroundImage: `url(${image.url})`,
    width: '100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative'
  }

  const [isVisible, setVisible] = React.useState(false);
  const domRef = React.useRef();
  React.useEffect(() => {
      const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  setVisible(entry.isIntersecting);
              }
          });
      });
      observer.observe(domRef.current);
      return () => observer.disconnect;
  }, []);

  return (
    <Holder className={`${isVisible ? 'animate-' + color : ''}`} ref={domRef} style={divStyle}>
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
      <Column />
    </Holder>
  )
}

export default PortraitAnimation;